export default "/images/device-3.jpg?103e009ff1afc47b814f18606809e8be";